module.exports = __webpack_public_path__ + "static/img/2.6d580d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/2.png
// module id = 94UM
// module chunks = 0